import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import {
    Label,
    Modal,
    Row,
    Button,
    UncontrolledTooltip,
} from "reactstrap"

import {
    // getMultipleCountryList as onGetMultipleCountryList,
    // changeMultipleCountryList as onChangeMultipleCountryList,
    // changeMadridSearchSettingsCountry as onChangeMadridSearchSettingsCountry,
    // changeFilerSearchSettingsCountry as onChangeFilerSearchSettingsCountry,
    setSettingsReducerValue,
    setReducerValue,
} from "../../store/actions";
import { cloneDeep, set } from 'lodash';
import { Link } from "react-router-dom";

const SelectAttachmentType = props => {
    const dispatch = useDispatch();
    const { view, emailFormIdx, docType, availableDocTypes } = props;
    const [modal_standard, setmodal_standard] = useState(false);
    const [attachmentTypeList, setAttachmentTypeList] = useState([
        { label: "RO/101", value: "RO101", checked: false, show: true },
        { label: "IB/301", value: "IB301", checked: false, show: true },
        { label: "No attachment", value: "", checked: false, show: true },
    ]);


    const openModal = (flag) => {
        // const selectedBranches = domainInfo.branch ? domainInfo.branch.split(', ') : [];

        const _attachmentTypeList = attachmentTypeList;

        if (flag) {
            if (view == "ST") {
                if (docType == null || docType == "") {
                    _attachmentTypeList.map((t) => {
                        if (t.value == "") {
                            t.checked = true;
                        } else {
                            t.checked = false;
                        }
                        t.show = true;
                    })
                } else {
                    const selectedTypes = docType.split(",");
                    _attachmentTypeList.map((t) => {
                        if (selectedTypes.includes(t.value)) {
                            t.checked = true;
                        } else {
                            t.checked = false;
                        }
                        t.show = true;
                    })
                }
            } else if (view == "PCTN") {
                if (
                    docType == null || docType == "" || 
                    availableDocTypes.filter(dt => dt.length > 0).length == 0 || 
                    docType.split(",").filter(t => availableDocTypes.includes(t)).length == 0
                ) {
                    _attachmentTypeList.map((t) => {
                        if (t.value == "") {
                            t.checked = true;
                        } else {
                            t.checked = false;
                        }
                        t.show = true;
                    })
                } else {
                    const selectedTypes = docType.split(",");
                    _attachmentTypeList.map((t) => {
                        if (selectedTypes.includes(t.value) && availableDocTypes.includes(t.value)) {
                            t.checked = true;
                        } else {
                            t.checked = false;
                        }
                        t.show = true;
                    })
                }
            }
        } else {
            _attachmentTypeList.map((t) => {
                t.checked = false;
                t.show = true;
            })
        }
        console.log("open modal: ", { docType, _attachmentTypeList })
        // dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
        setmodal_standard(!modal_standard);
        removeBodyCss();
    }

    // const search = (keyword) => {
    //     countryList.map((c) => {
    //         if (c.crCode.toLowerCase().includes(keyword) == true || (c.crName && c.crName.toLowerCase().includes(keyword) == true)) {
    //             c.show = true;
    //         } else {
    //             c.show = false;
    //         }
    //     })
    //     dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
    // }

    const targetCheck = (value, checked) => {
        const _attachmentTypeList = attachmentTypeList;
        _attachmentTypeList.map((t) => {
            if (t.value == value) {
                t.checked = checked;
            }
            // if (checked) {
            //     if (value == "") {
            //         if (t.value == "") {
            //             t.checked = checked;
            //         } else {
            //             t.checked = false;
            //         }
            //     } else {
            //         if (t.value == value) {
            //             t.checked = checked;
            //         } else if (t.value == "") {
            //             t.checked = false;
            //         }
            //     }
            // } else {
            //     if (t.value == value) {
            //         t.checked = checked;
            //     }

            // }
        })
        if (value != "") {
            _attachmentTypeList.find(t => t.value == "").checked = _attachmentTypeList.filter(t => t.value != "" && t.checked).length == 0;
        } else if (checked) {
            _attachmentTypeList.map((t) => {
                if (t.value != "") {
                    t.checked = false;
                }
            })
        }
        console.log("target check: ", { value, checked, _attachmentTypeList });
        setAttachmentTypeList(cloneDeep(_attachmentTypeList));
        // dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
    }

    const targetConfirm = () => {
        let selectedTypes = [];
        attachmentTypeList.map((t) => {
            if (t.checked) {
                selectedTypes.push(t.value);
            }
        })
        const selectedTypeStr = selectedTypes.join(",");
        console.log("selectedTypeStr: ", selectedTypeStr);
        if (view == "ST") {
            dispatch(
                setSettingsReducerValue(
                    'UPDATE_EMAIL_FORM_PCT_DOC_TYPE'
                    , {
                        title: 'Change attachment type?',
                        type: 'update',
                        idx: emailFormIdx,
                        pctDocType: selectedTypeStr,
                    }
                )
            );
        } else if (view == "PCTN") {
            dispatch(setReducerValue('PCT_DOC_TYPE', selectedTypeStr))
        }
        setmodal_standard(false);
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    // console.log("render: ", { docType, docTypeSplit: docType?.split(","), attachmentTypeList, availableDocTypes })

    return (
        <>
            <Row
                style={{ marginTop: "25px" }}>
                <label
                    className={`${view === "ST" ? "col-md-3" : "col-md-2"} col-form-label`}
                >
                    Attachment
                </label>
                <div className="col-md-9 d-flex align-items-center gap-2">
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }} >
                        {
                            view === "ST" ? (docType && docType != "" ? docType.split(",").map((t) => {
                                const typeInfo = attachmentTypeList.find(a => a.value == t);
                                return (
                                    <li key={t}>{typeInfo ? typeInfo.label : t}</li>
                                )
                            }) : <li>No attachment</li>) : null
                        }
                        {
                            view === "PCTN" ? (
                                docType &&
                                    docType != "" &&
                                    availableDocTypes.filter(dt => dt.length > 0).length > 0 &&
                                    docType.split(",").some(t => availableDocTypes.includes(t)) ?
                                    docType.split(",").map((t) => {
                                        if (availableDocTypes.includes(t) && t.length > 0) {
                                            const typeInfo = attachmentTypeList.find(a => a.value == t);
                                            return (
                                                <li key={t}>{typeInfo ? typeInfo.label : t}</li>
                                            )
                                        }
                                    })
                                    : <li>No attachment</li>) : null
                        }
                    </ul>
                    <Button
                        type="button"
                        color="outline-primary"
                        className="w-md"
                        style={{ marginLeft: '40px' }}
                        onClick={() => {
                            openModal(true)
                        }}
                    >
                        Select attachments
                    </Button>
                    {
                        view === "ST" && (
                            <span>
                                <i className="uil uil-info-circle font-size-18 text-warning" id={"PCTDocTypeInfo"}></i>
                                <UncontrolledTooltip placement="right" target={"PCTDocTypeInfo"} className="domain-correct-tooltip">
                                    Selected attachment will only be applied if the document is available for the specific case. If the document is not available, email will be sent without attachment.
                                </UncontrolledTooltip>
                            </span>
                        )
                    }
                    {
                        view === "PCTN" && docType != "" && docType?.split(",").filter(dt => !availableDocTypes?.includes(dt)).length > 0 && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: "3px", marginTop: "5px" }}>
                                <i className="uil uil-info-circle font-size-14 text-warning"></i>
                                <span className='text-warning font-size-14'>
                                    Your default attachment ({docType.split(",").filter(dt => !availableDocTypes.includes(dt)).join(", ")}) is not available for this case.
                                </span>
                            </span>
                        )
                    }
                </div>
            </Row>
            <Modal
                isOpen={modal_standard}
                toggle={() => {
                    openModal(false)
                }}
                scrollable={true}
            >
                <div className="modal-header" style={{ marginRight: "20px" }}>
                    <h5 className="modal-title mt-0" id="myModalLabel">
                        Select attachments
                    </h5>
                    {/* <div className="app-search" style={{ padding: '0' }}>
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "solid 1px" }}
                                placeholder="Search..."
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        search(e.target.value); // check
                                    }
                                }}
                            />
                            <span className="uil-search"></span>
                        </div>
                    </div> */}
                    <button
                        type="button"
                        onClick={() => {
                            openModal(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {
                        attachmentTypeList && attachmentTypeList.length &&
                        attachmentTypeList.map((c, index) => {
                            return (
                                c.show ?
                                    <div className="form-check mb-2" key={c.value}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={c.label}
                                            checked={c.checked}
                                            onClick={(e) => targetCheck(c.value, e.target.checked)}
                                            disabled={view === "PCTN" && c.value != "" && !availableDocTypes?.includes(c.value)}
                                        />
                                        <Label
                                            htmlFor={c.label}
                                            className={"form-check-label pointer"}
                                            style={(view === "PCTN" && c.value != "" && !availableDocTypes?.includes(c.value) ? { color: "rgb(173, 175, 176)" } : {})}
                                        >
                                            {c.label}
                                            {/* {
                                                 view === "PCTN" && c.value != "" && !availableDocTypes?.includes(c.value) ? 
                                                    <>
                                                        &nbsp;&nbsp;&nbsp;(<i className="uil uil-info-circle font-size-14 text-warning" style={{marginRight: "5px"}}></i>
                                                        not available for this case)
                                                    </> 
                                                        : ""
                                            } */}
                                        </Label>
                                    </div>

                                    : null
                            )
                        })
                    }
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        onClick={() => {
                            openModal(false)
                        }}
                        className="btn btn-secondary waves-effect"
                        data-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={() => targetConfirm()}
                    >
                        Confirm
                    </button>
                </div>
            </Modal>
        </>
    )
};

export default SelectAttachmentType;